function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

function SvgCamera(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 327.6 327.6",
    style: {
      enableBackground: "new 0 0 327.6 327.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4A566E"
    },
    d: "M30,67.8h63.2v-9.6c0-12,9.6-21.6,21.6-21.6h98c12,0,21.6,9.6,21.6,21.6v9.6h63.2 c16.4,0,30,13.6,30,30V261c0,16.4-13.6,30-30,30H30c-16.4,0-30-13.6-30-30V97.8C0,81,13.6,67.8,30,67.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00B594"
    },
    d: "M209.2,134.2c-11.6-11.6-27.6-18.4-45.2-18.4s-33.6,7.2-45.2,18.8c-11.6,11.6-18.8,27.6-18.8,45.2 s7.2,33.6,18.8,45.2s27.6,18.8,45.2,18.8s33.6-7.2,45.2-18.8c11.6-11.6,18.8-27.6,18.8-45.2C227.6,161.8,220.4,145.8,209.2,134.2z  M164,99c22,0,42.4,8.8,56.8,23.6c14.4,14.4,23.6,34.8,23.6,56.8s-8.8,42.4-23.6,56.8c-14.4,14.4-34.8,23.6-56.8,23.6 s-42.4-8.8-56.8-23.6c-14.4-14.4-23.6-34.8-23.6-56.8s8.8-42.4,23.6-56.8C121.6,107.8,142,99,164,99z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 280.8,
    cy: 114.2,
    r: 16
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 164,
    cy: 179.4,
    r: 44
  })), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.e26b0906.svg";
export { ForwardRef as ReactComponent };